import * as React from "react";

const AlertDialog = React.forwardRef(
  ({ children, open, onOpenChange, ...props }, ref) => {
    if (!open) return null;

    return (
      <div
        ref={ref}
        className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center"
        onClick={() => onOpenChange?.(false)}
        {...props}
      >
        {children}
      </div>
    );
  }
);
AlertDialog.displayName = "AlertDialog";

const AlertDialogContent = React.forwardRef(
  ({ children, className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        onClick={(e) => e.stopPropagation()}
        className={`bg-white rounded-lg shadow-lg p-6 w-full max-w-md mx-4 ${className}`}
        {...props}
      >
        {children}
      </div>
    );
  }
);
AlertDialogContent.displayName = "AlertDialogContent";

const AlertDialogHeader = React.forwardRef(
  ({ children, className, ...props }, ref) => {
    return (
      <div ref={ref} className={`mb-4 ${className}`} {...props}>
        {children}
      </div>
    );
  }
);
AlertDialogHeader.displayName = "AlertDialogHeader";

const AlertDialogTitle = React.forwardRef(
  ({ children, className, ...props }, ref) => {
    return (
      <h2 ref={ref} className={`text-lg font-semibold ${className}`} {...props}>
        {children}
      </h2>
    );
  }
);
AlertDialogTitle.displayName = "AlertDialogTitle";

const AlertDialogDescription = React.forwardRef(
  ({ children, className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`text-sm text-gray-500 mt-2 ${className}`}
        {...props}
      >
        {children}
      </div>
    );
  }
);
AlertDialogDescription.displayName = "AlertDialogDescription";

const AlertDialogFooter = React.forwardRef(
  ({ children, className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`mt-4 flex justify-end space-x-2 ${className}`}
        {...props}
      >
        {children}
      </div>
    );
  }
);
AlertDialogFooter.displayName = "AlertDialogFooter";

const AlertDialogAction = React.forwardRef(
  ({ children, className, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={`px-4 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 ${className}`}
        {...props}
      >
        {children}
      </button>
    );
  }
);
AlertDialogAction.displayName = "AlertDialogAction";

const AlertDialogCancel = React.forwardRef(
  ({ children, className, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={`px-4 py-2 border border-gray-300 rounded hover:bg-gray-100 ${className}`}
        {...props}
      >
        {children}
      </button>
    );
  }
);
AlertDialogCancel.displayName = "AlertDialogCancel";

const AlertDialogComponent = () => null;

export {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogComponent,
};
